const action = "MODEL_PROMOTE";
export const REQUEST = action+'_REQUEST';
export const RESPONSE = action+'_RESPONSE';
export const CLEAR = action+'_CLEAR';
export const FAILURE = action+'_FAILURE';

export const promoteRequest = (payload) => {
    return {
        type: REQUEST,
        payload
    };
};

export const promoteSuccess = (response) => ({
  type: RESPONSE,
  payload: response
});

export const clearState = (response) => ({
  type: CLEAR
});

export const promoteFailure = (error) => ({
  type: FAILURE,
  payload: error
}); 